<script>
export default {
    data() {
        return {};
    },
    computed: {
        modal() {
            return this.$children[0];
        },
    },
    mounted() {
        this.modal.$on('hidden', () => this.$emit('hidden'));
    },
    methods: {
        show() {
            this.modal.show();
        },
        hide() {
            this.modal.hide();
        },
    },
};
</script>
